import { CategoryTagsProps } from "/Models/Generated/CategoryTagsProps";
import "./CategoryTags.scss";
import ButtonFilter from "../ButtonFilter/ButtonFilter";
import { createSpreadableBem } from "/Helpers/createBem";

const CategoryTags = ({ heading, links }: CategoryTagsProps) => {
  const bem = createSpreadableBem("category-tags-norad");
  return (
    <aside {...bem("")}>
      {heading && <h2 {...bem("__heading")}>{heading}</h2>}
      <div {...bem("__links")}>
        {links &&
          links.map((link, idx) => (
            <ButtonFilter
              key={idx}
              caption={link.text ?? ""}
              href={link.href}
              asLink
              selected={false}
            />
          ))}
      </div>
    </aside>
  );
};

export default CategoryTags;
